import React from 'react';
import { Modal, StackLayout } from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import { MainPageContainer } from '@leagueplatform/web-common-components';
import { HeroSection } from 'components/hero-section/hero-section.component';
import { AutomaticPaymentSetupMasonrySection } from 'components/premium-payment/automatic-payment-setup-masonry-section.component';
import { UnsaveChangesWarningModal } from 'components/modals/unsave-changes-warning-modal.component';
import { useAutomaticPaymentSetup } from 'hooks/use-automatic-payment-setup.hook';

const AutomaticPaymentsSetupPage = () => {
  const { formatMessage: t } = useIntl();
  const {
    showUnsavedModal,
    handleUnsavedConfirm,
    handleUnsavedSave,
    handleGoback,
  } = useAutomaticPaymentSetup();

  const title = t({ id: 'STR_AUTOMATIC_PAYMENT_SETUP' });

  return (
    <MainPageContainer
      width="100%"
      css={{
        '.GDS-vertical-stack-layout': {
          width: '100%',
          gap: '0 !important',
        },
        // Apply spacing only to visible stack items (not hidden masonry items)
        '.GDS-stack-item:not(:has(.hidden-masonry-subtree))': {
          marginBottom: '16px',
        },
        // Remove bottom margin from last visible item
        '.GDS-stack-item:not(:has(.hidden-masonry-subtree)):last-child': {
          marginBottom: '0',
        },
        button: {
          textAlign: 'center',
          justifyContent: 'center',
          maxWidth: '327px',
        },
        input: {
          maxWidth: '327px',
        },
        '.GDS-select': {
          maxWidth: '327px',
        },
      }}
    >
      <HeroSection title={title} height="120px" goBack={handleGoback} />
      <StackLayout>
        <StackLayout
          css={{
            marginBottom: '$four',
            marginTop: '$one',
            a: {
              width: '240px',
              '@mobile': {
                width: '100%',
              },
            },
            '.GDS-input-wrapper': {
              flexDirection: 'column !important',
            },
          }}
        >
          <AutomaticPaymentSetupMasonrySection />
        </StackLayout>
      </StackLayout>
      <Modal.Root open={showUnsavedModal} onOpenChange={handleUnsavedSave}>
        <UnsaveChangesWarningModal
          title={t({ id: 'STR_AUTOMATIC_PAYMENT_SETUP_UNSAVE_MODAL_TITLE' })}
          description={t({
            id: 'STR_AUTOMATIC_PAYMENT_SETUP_UNSAVE_MODAL_DESCRIPTION',
          })}
          cancelButtonText={t({
            id: 'STR_AUTOMATIC_PAYMENT_SETUP_UNSAVE_MODAL_CANCEL',
          })}
          confirmButtonText={t({
            id: 'STR_AUTOMATIC_PAYMENT_SETUP_UNSAVE_MODAL_CONFIRM',
          })}
          onConfirm={handleUnsavedConfirm}
          onClose={handleUnsavedSave}
        />
      </Modal.Root>
    </MainPageContainer>
  );
};

export default AutomaticPaymentsSetupPage;
